<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ $t($route.name) }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-menu
        offset-y
        v-if="isMobile || isTablet"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="getItems"
          >
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important;padding: 0 !important;"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('filter') }}
        </p>
        <v-icon>
          mdi-filter-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4  ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('print') }}
        </p>
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row class="mx-0">
      <v-col
        cols="12"
        md="3"
        sm="3"
        class="px-2"
      >
        <template>
          <v-text-field
            id="expireDate"
            v-model="expireDate"
            :label="$t('expireDateRang')"
            :rules="[v => !!v || $t('is-required')]"
            clear-icon="flaticon2-close-cross"
            outlined
            hide-details
            dense
            clearable
          />

          <date-picker
            v-model="expireDate"
            element="expireDate"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            rang
            :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
            range
            clearable
          />
        </template>
      </v-col>
    </v-row>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
    >
      <v-col
        class="mb-4 px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
      :class="{ 'mt-2': !isMobile && !isTablet , 'mt-0': isMobile || isTablet}"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :hide-default-header="isMobile || mobileShow"
        multi-sort
        :page.sync="page"
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                v-if="item.head"
                v-clipboard:copy="$baseURL + '/' + item.head.type +'/edit/' + item.id"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.head.type="{ item }">
          <v-btn
            v-if="item.head"
            :loading="loading"
            class="ma-0 px-1"
            :color="(item.head.type === 'remittance' ? 'pink' : (item.head.type === 'receipt' ? 'teal' : 'blue'))"
            plain
            @click="(item.head.type !== 'initial' && item.head.type !== 'production'? edit(item) : null)"
          >
            {{ $t(item.head.type) }} {{ $t('number') }} : {{ item.head.id }}
          </v-btn>
          <v-chip
            v-if="item.head && item.head.invoice"
            :color="(item.head.type === 'remittance' ? 'pink' : (item.head.type === 'receipt' ? 'teal' : 'blue'))"
            small
            outlined
            label
            @click="invoice(item)"
          >
            {{ $t(item.head.invoice.type) }} - {{ $t('number') }} {{ item.head.invoice.number }} (id:{{ item.head.invoice.id }}) {{ (item.head && item.head.invoice && item.head.invoice.customer ? ' - ' + item.head.invoice.customer.name : '') }}
          </v-chip>
          <v-chip
            v-if="item.head && item.head.production"
            color="teal"
            small
            outlined
            label
            @click="invoice(item)"
          >
            {{ $t(item.head.production.type) }} - {{ $t('number') }} {{ item.head.production.number }} (id:{{ item.head.production.id }})
          </v-chip>
        </template>
        <template v-slot:item.price="{ item }">
          {{ $numberFormat(item.price) }}
        </template>
        <!-- <template v-slot:item.in="{ item }">
          {{ $numberFormat(item.in) }} {{ (item.unit2 && item.in ? '(' + item.countUnit + ' ' + item.unit2.fame + ')' : '') }}
        </template> -->
        <!-- <template v-slot:item.out="{ item }">
          {{ $numberFormat(item.out) }} {{ (item.unit2 && item.out ? '(' + item.countUnit + ' ' + item.unit2.fame + ')' : '') }}
        </template> -->
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.row="{ item }">
          <a @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.sumCount="{ item }">
          {{ $numberFormat(item.sumCount) }}
        </template>
        <template v-slot:item.sumAmount="{ item }">
          {{ $numberFormat(item.sum) }}
        </template>
        <template v-slot:footer.prepend>
          <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
          >
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
        <template
          v-slot:body.append
        >
          <tr :class="{'v-data-table__mobile-table-row':isMobile}">
            <td
              :colspan="`${isMobile?6: 6}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('in') + ':' : '') }} {{ $numberFormat(totals.in) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('out') + ':' : '') }} {{ $numberFormat(totals.out) }}
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ $t('remain') }} : {{ $numberFormat(parseFloat(totals.in) - parseFloat(totals.out)) }}
            </td>
            <td
              :colspan="`${isMobile?6:4}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            />
          </tr>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="product"
              type="product"
              :title="$t('product')"
              :outlined="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="entrepot"
              :title="$t('entrepot')"
              type="entrepot"
              :outlined="true"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  import autocomplete from '../../components/general/patial/autocomplete'
  export default {
    name: 'ProductTurnover',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Print,
      autocomplete,
      Task,
    },
    mixins: [General],
    props: ['input', 'refId', 'productProp', 'entrepotProp', 'idProp', 'mobileShow'],
    data: () => ({
      selected: [],
      pageCount: 1,
      page: 1,
      printDialog: false,
      deletDialog: false,
      showSelect: true,
      filter: false,
      sumAmount: 0,
      sumCount: 0,
      expireDate: null,
      entrepot: null,
      product: null,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
      fin4: null,
      given: null,
      excelItems: [],
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.$route.name === 'productCountTurnover') {
            if (s.value === 'price' || s.value === 'sumAmount') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else if (app.$route.name === 'productTurnover') {
            if (s.value === 'sumCount' || s.value === 'sumAmount') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            if (app.$route.name === 'productCountTurnover' && s.value === 'sumAmount') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          }
        })
      },
      // sum: function () {
      //   return this.items.reduce(function (sum, item) {
      //     return parseFloat(sum) + parseFloat(item.price)
      //   }, 0)
      // },
      totals: function () {
        var app = this
        app.excelItems = []
        const totals = this.items.reduce((acc, d) => {
          acc.in += (d.in ? parseFloat(d.in) : 0)
          acc.out += (d.out ? parseFloat(d.out) : 0)
          app.excelItems.push({
            id: d.id,
            type: app.$t(d.head.type) + ' ' + app.$t('number') + ' ' + d.head.id,
            warehouse: (d.entrepot ? d.entrepot.name : ''),
            date: (d.head ? d.head.date : ''),
            product: (d.product ? d.product.name : ''),
            unit: (d.unit ? d.unit.name : ''),
            in: d.in,
            out: d.out,
            fee: d.price,
          })
          return acc
        }, {
          in: 0,
          out: 0,
        })
        return totals
      },
    },
    watch: {
      idProp () {
        this.getItems()
      },
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      expireDate () {
        this.getItems()
      },
    },
    beforeMount () {
      if (this.$route.name === 'purchaseList') {
        this.type = 'purchase'
      }
      if (this.$route.name === 'presaleList') {
        this.type = 'presale'
      }
      if (this.$route.name === 'sellList') {
        this.type = 'sell'
      }
      if (this.$route.name === 'purchaseReturnList') {
        this.type = 'purchaseReturn'
      }
      if (this.$route.name === 'sellReturnList') {
        this.type = 'sellReturn'
      }
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('product'),
          sortable: true,
          value: 'product.name',
          table: 'products.name',
        },
        {
          text: this.$t('enterDate'),
          sortable: true,
          value: 'head.date',
          table: 'entrepot_head.date',
        },
        {
          text: this.$t('entrepot'),
          sortable: true,
          value: 'entrepot.name',
          table: 'entrepots.name',
        },
        {
          text: this.$t('expireDate'),
          sortable: true,
          value: 'expire_date',
          table: 'entrepot_article.expire_date',
        },
        // {
        //   text: this.$t('countIn'),
        //   sortable: false,
        //   value: 'in',
        //   table: 'entrepot_article.in',
        // },
        // {
        //   text: this.$t('countOut'),
        //   sortable: false,
        //   value: 'sum_out',
        //   table: 'entrepot_article.out',
        // },
        // {
        //   text: this.$t('countStock'),
        //   sortable: false,
        //   value: 'remain',
        // },
        {
          text: this.$t('unit'),
          sortable: false,
          value: 'unit.fame',
        },
      ]
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
    },
    mounted () {
      var mStart = this.$moment()
      var mEnd = this.$moment().add(30, 'day')
      if (this.$store.state.date_locale === 'fa,en') {
        this.expireDate = [mStart.format('jYYYY/jMM/jDD'), mEnd.format('jYYYY/jMM/jDD')]
      }
      if (this.$store.state.date_locale === 'en,fa') {
        this.expireDate = [mStart.format('YYYY/MM/DD'), mEnd.format('YYYY/MM/DD')]
      }
      this.getItems()
    },
    methods: {
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: item.head.type + 'Edit', params: { id: item.head.id } })
      },
      invoice (item) {
        if (item.head.type === 'production') {
          this.$router.push({ name: item.head.production.type + 'Edit', params: { id: item.head.production.id } })
        } else {
          this.$router.push({ name: item.head.invoice.type + 'Edit', params: { id: item.head.invoice.uid } })
        }
      },
      getItems () {
        var app = this
        app.loading = true
        var productId = (app.productProp ? app.productProp.id : null)
        productId = (this.$route.params.id ? this.$route.params.id : productId)
        app.$axios.get(this.$endpoint + 'productsreport', {
          params: {
            product_id: (app.product ? app.product.id : null),
            productProp_id: productId,
            entrepotProp: (!app.entrepot ? app.entrepotProp : null),
            entrepot: app.entrepot,
            search: app.search,
            page: app.options.page,
            refId: app.refId,
            branch: app.branch,
            idProp: app.idProp,
            type: app.type,
            report: 'expireDateItems',
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
            name: app.$route.name,
            expireDate: app.expireDate,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.pageCount = res.last_page
            app.from = res.from
            if (app.options.page === 1) {
              app.sumAmount = 0
              app.sumCount = 0
            }
            app.items.map(function (value, key) {
              if (value.in > 0 || value.out > 0) {
                if (value.in > 0) {
                  app.sumAmount = parseFloat(app.sumAmount) + (parseFloat(value.price) * parseFloat(value.in))
                  app.sumCount = parseFloat(app.sumCount) + parseFloat(value.in)
                } else {
                  app.sumCount = parseFloat(app.sumCount) - parseFloat(value.out)
                  app.sumAmount = parseFloat(app.sumAmount) - (parseFloat(value.price) * parseFloat(value.out))
                }
              }
              value.sum = app.sumAmount
              value.sumCount = app.sumCount
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'invoice/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
